import { ActionReducer, Action } from '@ngrx/store';
import { initialLargeShareholderListState, ILargeShareholderListState } from '../states/large-shareholder-list.state';
import { ELargeShareholderListActions, SetSearchFilter, SetPagination, SetSort } from '../actions/large-shareholder-list.actions';

export const largeShareholderListReducers: ActionReducer<ILargeShareholderListState, Action<string>> = (
  state = initialLargeShareholderListState,
  action: Action<string>
) => {
  switch (action.type) {
    case ELargeShareholderListActions.SetSearchFilter: {
      const typedAction = action as SetSearchFilter;
      return {
        ...state,
        searchFilter: typedAction.payload,
        currentPage: 1 // Reset to first page when search changes
      };
    }

    case ELargeShareholderListActions.SetPagination: {
      const typedAction = action as SetPagination;
      return {
        ...state,
        currentPage: typedAction.payload.currentPage,
        pageSize: typedAction.payload.pageSize
      };
    }

    case ELargeShareholderListActions.SetSort: {
      const typedAction = action as SetSort;
      return {
        ...state,
        sortBy: typedAction.payload.sortBy,
        ascending: typedAction.payload.ascending
      };
    }

    case ELargeShareholderListActions.ClearFilters: {
      return {
        ...initialLargeShareholderListState
      };
    }

    default:
      return state;
  }
};
